export const VoucherActionType = {
  Delete:     'Delete',
  Activate:   'Activate',
  Deactivate: 'Deactivate',
};

export const DesignTypeOptions = {
  Manual:   'Manual',
  Template: 'Template',
};

export const AvailableImages = [
  {
    image: '/images/loyalty-design-available/Loyalty-Card-Angles-Blue.png',
    top:   '/images/loyalty-design-template/lc-angles-blue-top.png',
    btm:   '/images/loyalty-design-template/lc-angles-blue-btm.png',
  },
  {
    image: '/images/loyalty-design-available/Loyalty-Card-Angles-Green.png',
    top:   '/images/loyalty-design-template/lc-angles-green-top.png',
    btm:   '/images/loyalty-design-template/lc-angles-green-btm.png',
  },
  {
    image: '/images/loyalty-design-available/Loyalty-Card-Angles-Purple.png',
    top:   '/images/loyalty-design-template/lc-angles-purple-top.png',
    btm:   '/images/loyalty-design-template/lc-angles-purple-btm.png',
  },
  {
    image: '/images/loyalty-design-available/Loyalty-Card-Angles-Red.png',
    top:   '/images/loyalty-design-template/lc-angles-red-top.png',
    btm:   '/images/loyalty-design-template/lc-angles-red-btm.png',
  },
  {
    image: '/images/loyalty-design-available/Loyalty-Card-Angles-Yellow.png',
    top:   '/images/loyalty-design-template/lc-angles-yellow-top.png',
    btm:   '/images/loyalty-design-template/lc-angles-yellow-btm.png',
  },
  {
    image: '/images/loyalty-design-available/Loyalty-Card-Curves-Blue.png',
    top:   '/images/loyalty-design-template/lc-curves-blue-top.png',
    btm:   '/images/loyalty-design-template/lc-curves-blue-btm.png',
  },
  {
    image: '/images/loyalty-design-available/Loyalty-Card-Curves-Green.png',
    top:   '/images/loyalty-design-template/lc-curves-green-top.png',
    btm:   '/images/loyalty-design-template/lc-curves-green-btm.png',
  },
  {
    image: '/images/loyalty-design-available/Loyalty-Card-Curves-Purple.png',
    top:   '/images/loyalty-design-template/lc-curves-purple-top.png',
    btm:   '/images/loyalty-design-template/lc-curves-purple-btm.png',
  },
  {
    image: '/images/loyalty-design-available/Loyalty-Card-Curves-Red.png',
    top:   '/images/loyalty-design-template/lc-curves-red-top.png',
    btm:   '/images/loyalty-design-template/lc-curves-red-btm.png',
  },
  {
    image: '/images/loyalty-design-available/Loyalty-Card-Curves-Yellow.png',
    top:   '/images/loyalty-design-template/lc-curves-yellow-top.png',
    btm:   '/images/loyalty-design-template/lc-curves-yellow-btm.png',
  },
];

export const VoucherImages = {
  Green:  '/images/voucher-green.png',
  Blue:   '/images/voucher-blue.png',
  Brown:  '/images/voucher-brown.png',
  Red:    '/images/voucher-red.png',
  Yellow: '/images/voucher-yellow.png',
};

export const VoucherStyles = {
  [VoucherImages.Green]:  { fontColor: '#4a874e' },
  [VoucherImages.Blue]:   { fontColor: '#6e8399' },
  [VoucherImages.Brown]:  { fontColor: '#a28f77' },
  [VoucherImages.Red]:    { fontColor: '#c59598' },
  [VoucherImages.Yellow]: { fontColor: '#d59c01' },
};
